import React, {FC} from "react"
import styled from "styled-components"

import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
/* eslint-disable no-restricted-imports */
/** @description: Tech debt, this should be moved outside the ui folder */
import authentication from "@irati/auth"
/* eslint-enable no-restricted-imports */

import Flex from "../../Flex"
import ProfilePic from "../../ProfilePicture"
import {Dosis} from "../../global/fonts"

const Name = styled.span`
  font-size: 21px;
  margin-left: 10px;
  ${Dosis};
`

const ProfileHeader: FC = () => {
  const user = authentication.user()

  return (
    <Flex alignItems="center" padding="10px 0">
      <ProfilePic user={user} small />
      <Name>{firstnameLastname(user)}</Name>
    </Flex>
  )
}

export default ProfileHeader
